const translations = {
  en: {
    // App / Nav
    appName: 'SafeRoster',
    staffLogin: '🔐 Staff / Admin Login',
    loggedInAs: 'Logged in as',
    logout: 'Logout',
    back: '← Back',
    switchOrg: 'Switch Org',
    loading: 'Loading...',

    // Language toggle
    langToggle: 'Español',

    // Home Menu
    checkIn: 'Check-In',
    checkOut: 'Check-Out',
    staffDashboard: 'Staff Dashboard',
    reports: 'Reports',
    adminPanel: 'Admin Panel',
    settings: 'Settings',
    classroomView: 'Classroom View',
    upgradePro: 'Upgrade to Pro — $29/mo',

    // OrgSetup
    selectOrCreateOrg: 'Select or create your organization',
    yourOrganizations: 'Your Organizations',
    createNewOrg: '+ Create New Organization',
    newOrganization: 'New Organization',
    orgName: 'Organization Name',
    orgType: 'Organization Type',
    createOrganization: 'Create Organization',
    cancel: 'Cancel',
    noOrgsYet: 'No organizations yet. Create one above!',
    school: 'School',
    daycare: 'Daycare',
    church: 'Church / Sunday School',
    event: 'Event',
    deleteOrgConfirm: (name) => `Are you sure you want to delete ${name}? This cannot be undone.`,
    yesDelete: 'Yes, Delete',

    // Register / Check-In
    checkInTitle: '👶 Check-In',
    enterPhonePrompt: 'Enter your phone number to get started',
    parentPhone: "Parent's Phone Number",
    continue: 'Continue',
    searching: 'Searching...',
    welcomeBack: '👋 Welcome Back!',
    welcomeBackSub: (name) => `Hi ${name}! Select children to check in`,
    alreadyCheckedIn: 'Already checked in today',
    emergency: 'Emergency',
    notSet: 'Not set',
    notes: 'Notes',
    checkInSelected: (n) => `Check In ${n} ${n === 1 ? 'Child' : 'Children'}`,
    checkingIn: 'Checking In...',
    registerChildren: '📋 Register Children',
    fillInfoBelow: 'Fill in your information below',
    parentInfo: 'Parent Information',
    parentFullName: "Parent's Full Name *",
    emergencyContact: 'Emergency Contact',
    emergencyContactName: 'Emergency Contact Name',
    emergencyContactPhone: 'Emergency Contact Phone',
    createPickupPin: '🔐 Create Pickup PIN',
    pinRequired: 'This 4 digit PIN will be required every time you pick up your children',
    createPin: 'Create 4 digit PIN *',
    confirmPin: 'Confirm PIN *',
    children: '👶 Children',
    addAllChildren: 'Add all children you want to check in today',
    childNumber: (n) => `Child ${n}`,
    childFullName: "Child's Full Name *",
    notesOptional: 'Notes (optional)',
    remove: 'Remove',
    addAnotherChild: '+ Add Another Child',
    registerAndCheckIn: (n) => `Register & Check In ${n > 1 ? `${n} Children` : '1 Child'}`,
    registering: 'Registering...',
    backToMyChildren: '← Back to My Children',
    registerAnotherChild: '+ Register Another Child',
    pleaseFillFields: 'Please fill in all required fields.',
    pleaseEnterChildName: 'Please enter a name for each child.',
    pleaseEnter4DigitPin: 'Please enter a 4 digit pickup PIN.',
    pinsDoNotMatch: 'PINs do not match. Please try again.',
    dailyLimitReached: '⚠️ You have reached your daily limit of 15 check-ins. Upgrade to Pro for unlimited check-ins!',
    pleaseEnterPhone: 'Please enter a phone number.',

    // CheckOut
    pickUpChild: '👋 Pick Up My Child',
    enterPhoneToStart: 'Enter your phone number to get started',
    search: 'Search',
    pleaseEnterPhoneSearch: 'Please enter a phone number to search.',
    noChildrenFound: 'No children found with that phone number.',
    noActiveCheckins: 'No active check-ins found for that phone number.',
    selectChildrenPickup: 'Select children to pick up',
    checkedInAt: 'Checked in at',
    continueWith: (n) => `Continue with ${n} ${n === 1 ? 'Child' : 'Children'} →`,
    enterPickupPin: '🔐 Enter Pickup PIN',
    verifyingPickupFor: (names) => `Verifying pickup for ${names}`,
    pleaseEnter4Pin: 'Please enter your 4 digit PIN.',
    incorrectPin: 'Incorrect PIN. Please try again.',
    forgotPin: '⚠️ Forgot your PIN?',
    forgotPinDesc: 'Please see a staff member at the front desk to complete the checkout process. For security purposes, PINs cannot be reset without staff verification.',
    verifyNotifyStaff: 'Verify & Notify Staff',
    staffNotified: 'Staff Notified!',
    waitingMessage: (names, plural) => `✅ Staff has been notified you are waiting for ${names}. Please wait while they bring your ${plural ? 'children' : 'child'}.`,
    remainInArea: 'Please remain in the pickup area. A staff member will bring your child shortly.',
    pleaseSelectChild: 'Please select at least one child.',

    // Login
    staffLoginTitle: '🔐 Staff Login',
    staffLoginSub: 'Only authorized staff can access the dashboard',
    email: 'Email',
    password: 'Password',
    login: 'Login',
    loggingIn: 'Logging in...',
    enterEmailPassword: 'Please enter your email and password.',
    forgotPassword: 'Forgot your password?',

    // Dashboard
    staffDashboardTitle: '📋 Staff Dashboard',
    liveFeed: 'Live view updates every 10 seconds',
    parentWaiting: (n) => `⏳ Parent${n > 1 ? 's' : ''} Waiting for Pickup`,
    tapToRelease: 'Tap to release child to parent',
    childrenCheckedIn: 'Children Currently Checked In',
    tapChildDetails: 'Tap a child to see details',
    noChildrenIn: 'No children currently checked in.',
    refresh: '🔄 Refresh',
    parentInfo2: 'Parent Info',
    name: 'Name',
    phone: 'Phone',
    emergencyContactTitle: 'Emergency Contact',
    noEmergencyContact: 'No emergency contact on file',
    notProvided: 'Not provided',
    checkedInAtTime: 'Checked in at',
    releaseToParent: '✅ Release Child to Parent',
    checkOutChild: (name) => `Check Out ${name}`,
    close: 'Close',
    waitingSince: 'Waiting since',
    inAt: 'In at',
    parent: 'Parent',

    // ClassroomView
    classroomViewTitle: 'Classroom View',
    enterPinAccess: 'Enter your classroom PIN to access',
    enter4DigitPin: 'Enter 4 digit PIN',
    enterClassroomView: 'Enter Classroom View →',
    verifying: 'Verifying...',
    errorVerifyingPin: 'Error verifying PIN.',
    incorrectPinTry: 'Incorrect PIN. Please try again.',
    parentsWaitingPickup: '⏳ Parents Waiting for Pickup',
    allClear: 'All Clear!',
    noParentsWaiting: 'No parents waiting for pickup right now.',
    waiting: 'Waiting',
    autoRefresh: 'Auto-refreshes every 10 seconds',
    exit: 'Exit',
    release: '✅ Release',
    waitingSinceTime: 'Waiting since',

    // Upgrade
    upgradeToPro: '⭐ Upgrade to Pro',
    unlockPower: 'Unlock the full power of SafeRoster',
    currentPlan: 'Current Plan',
    freePlan: (name) => `Free Plan — ${name}`,
    proPlan: 'Pro Plan',
    everythingYouNeed: 'Everything you need to run safely',
    perMonth: 'per month',
    securePayment: 'Secure payment powered by Stripe. Cancel anytime.',
    upgradeButton: 'Upgrade to Pro — $29/mo →',
    redirecting: 'Redirecting to Checkout...',
    freeIncludes: 'Free Plan includes:',
    freeFeatures: '15 daily check-ins, QR code check-in, PIN pickup, staff dashboard',

    // ForgotPassword
    forgotPasswordTitle: 'Forgot Password',
    forgotPasswordSub: 'Enter your email and we\'ll send a reset link',
    sendResetLink: 'Send Reset Link',
    sending: 'Sending...',
    backToLogin: '← Back to Login',
  },

  es: {
    // App / Nav
    appName: 'SafeRoster',
    staffLogin: '🔐 Inicio de Sesión Personal',
    loggedInAs: 'Conectado como',
    logout: 'Cerrar Sesión',
    back: '← Volver',
    switchOrg: 'Cambiar Organización',
    loading: 'Cargando...',

    // Language toggle
    langToggle: 'English',

    // Home Menu
    checkIn: 'Registro de Entrada',
    checkOut: 'Registro de Salida',
    staffDashboard: 'Panel de Personal',
    reports: 'Reportes',
    adminPanel: 'Panel de Administración',
    settings: 'Configuración',
    classroomView: 'Vista del Salón',
    upgradePro: 'Actualizar a Pro — $29/mes',

    // OrgSetup
    selectOrCreateOrg: 'Selecciona o crea tu organización',
    yourOrganizations: 'Tus Organizaciones',
    createNewOrg: '+ Crear Nueva Organización',
    newOrganization: 'Nueva Organización',
    orgName: 'Nombre de la Organización',
    orgType: 'Tipo de Organización',
    createOrganization: 'Crear Organización',
    cancel: 'Cancelar',
    noOrgsYet: '¡Aún no hay organizaciones. ¡Crea una arriba!',
    school: 'Escuela',
    daycare: 'Guardería',
    church: 'Iglesia / Escuela Dominical',
    event: 'Evento',
    deleteOrgConfirm: (name) => `¿Estás seguro de que deseas eliminar ${name}? Esta acción no se puede deshacer.`,
    yesDelete: 'Sí, Eliminar',

    // Register / Check-In
    checkInTitle: '👶 Registro de Entrada',
    enterPhonePrompt: 'Ingresa tu número de teléfono para comenzar',
    parentPhone: 'Número de Teléfono del Padre/Madre',
    continue: 'Continuar',
    searching: 'Buscando...',
    welcomeBack: '👋 ¡Bienvenido de Vuelta!',
    welcomeBackSub: (name) => `¡Hola ${name}! Selecciona los niños para registrar entrada`,
    alreadyCheckedIn: 'Ya registrado hoy',
    emergency: 'Emergencia',
    notSet: 'No establecido',
    notes: 'Notas',
    checkInSelected: (n) => `Registrar Entrada de ${n} ${n === 1 ? 'Niño' : 'Niños'}`,
    checkingIn: 'Registrando...',
    registerChildren: '📋 Registrar Niños',
    fillInfoBelow: 'Completa tu información a continuación',
    parentInfo: 'Información del Padre/Madre',
    parentFullName: 'Nombre Completo del Padre/Madre *',
    emergencyContact: 'Contacto de Emergencia',
    emergencyContactName: 'Nombre del Contacto de Emergencia',
    emergencyContactPhone: 'Teléfono del Contacto de Emergencia',
    createPickupPin: '🔐 Crear PIN de Recogida',
    pinRequired: 'Este PIN de 4 dígitos será requerido cada vez que recojas a tus hijos',
    createPin: 'Crear PIN de 4 dígitos *',
    confirmPin: 'Confirmar PIN *',
    children: '👶 Niños',
    addAllChildren: 'Agrega todos los niños que deseas registrar hoy',
    childNumber: (n) => `Niño ${n}`,
    childFullName: 'Nombre Completo del Niño *',
    notesOptional: 'Notas (opcional)',
    remove: 'Eliminar',
    addAnotherChild: '+ Agregar Otro Niño',
    registerAndCheckIn: (n) => `Registrar y Marcar Entrada de ${n > 1 ? `${n} Niños` : '1 Niño'}`,
    registering: 'Registrando...',
    backToMyChildren: '← Volver a Mis Niños',
    registerAnotherChild: '+ Registrar Otro Niño',
    pleaseFillFields: 'Por favor completa todos los campos requeridos.',
    pleaseEnterChildName: 'Por favor ingresa el nombre de cada niño.',
    pleaseEnter4DigitPin: 'Por favor ingresa un PIN de 4 dígitos.',
    pinsDoNotMatch: 'Los PINs no coinciden. Por favor intenta de nuevo.',
    dailyLimitReached: '⚠️ Has alcanzado el límite diario de 15 registros. ¡Actualiza a Pro para registros ilimitados!',
    pleaseEnterPhone: 'Por favor ingresa un número de teléfono.',

    // CheckOut
    pickUpChild: '👋 Recoger a Mi Hijo/a',
    enterPhoneToStart: 'Ingresa tu número de teléfono para comenzar',
    search: 'Buscar',
    pleaseEnterPhoneSearch: 'Por favor ingresa un número de teléfono para buscar.',
    noChildrenFound: 'No se encontraron niños con ese número de teléfono.',
    noActiveCheckins: 'No se encontraron entradas activas para ese número de teléfono.',
    selectChildrenPickup: 'Selecciona los niños a recoger',
    checkedInAt: 'Registrado a las',
    continueWith: (n) => `Continuar con ${n} ${n === 1 ? 'Niño' : 'Niños'} →`,
    enterPickupPin: '🔐 Ingresar PIN de Recogida',
    verifyingPickupFor: (names) => `Verificando recogida para ${names}`,
    pleaseEnter4Pin: 'Por favor ingresa tu PIN de 4 dígitos.',
    incorrectPin: 'PIN incorrecto. Por favor intenta de nuevo.',
    forgotPin: '⚠️ ¿Olvidaste tu PIN?',
    forgotPinDesc: 'Por favor acércate a un miembro del personal en la recepción para completar el proceso de salida. Por razones de seguridad, los PINs no pueden restablecerse sin verificación del personal.',
    verifyNotifyStaff: 'Verificar y Notificar al Personal',
    staffNotified: '¡Personal Notificado!',
    waitingMessage: (names, plural) => `✅ El personal ha sido notificado que estás esperando a ${names}. Por favor espera mientras traen a ${plural ? 'tus hijos' : 'tu hijo/a'}.`,
    remainInArea: 'Por favor permanece en el área de recogida. Un miembro del personal traerá a tu hijo/a en breve.',
    pleaseSelectChild: 'Por favor selecciona al menos un niño.',

    // Login
    staffLoginTitle: '🔐 Inicio de Sesión del Personal',
    staffLoginSub: 'Solo el personal autorizado puede acceder al panel',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    login: 'Iniciar Sesión',
    loggingIn: 'Iniciando sesión...',
    enterEmailPassword: 'Por favor ingresa tu correo y contraseña.',
    forgotPassword: '¿Olvidaste tu contraseña?',

    // Dashboard
    staffDashboardTitle: '📋 Panel de Personal',
    liveFeed: 'Vista en vivo, se actualiza cada 10 segundos',
    parentWaiting: (n) => `⏳ ${n > 1 ? 'Padres' : 'Padre/Madre'} Esperando Recogida`,
    tapToRelease: 'Toca para liberar al niño con el padre/madre',
    childrenCheckedIn: 'Niños Actualmente Registrados',
    tapChildDetails: 'Toca un niño para ver detalles',
    noChildrenIn: 'No hay niños registrados actualmente.',
    refresh: '🔄 Actualizar',
    parentInfo2: 'Info del Padre/Madre',
    name: 'Nombre',
    phone: 'Teléfono',
    emergencyContactTitle: 'Contacto de Emergencia',
    noEmergencyContact: 'No hay contacto de emergencia registrado',
    notProvided: 'No proporcionado',
    checkedInAtTime: 'Registrado a las',
    releaseToParent: '✅ Liberar Niño al Padre/Madre',
    checkOutChild: (name) => `Registrar Salida de ${name}`,
    close: 'Cerrar',
    waitingSince: 'Esperando desde',
    inAt: 'Entrada a las',
    parent: 'Padre/Madre',

    // ClassroomView
    classroomViewTitle: 'Vista del Salón',
    enterPinAccess: 'Ingresa tu PIN del salón para acceder',
    enter4DigitPin: 'Ingresa PIN de 4 dígitos',
    enterClassroomView: 'Entrar a Vista del Salón →',
    verifying: 'Verificando...',
    errorVerifyingPin: 'Error al verificar el PIN.',
    incorrectPinTry: 'PIN incorrecto. Por favor intenta de nuevo.',
    parentsWaitingPickup: '⏳ Padres Esperando Recogida',
    allClear: '¡Todo Despejado!',
    noParentsWaiting: 'No hay padres esperando recogida en este momento.',
    waiting: 'Esperando',
    autoRefresh: 'Se actualiza automáticamente cada 10 segundos',
    exit: 'Salir',
    release: '✅ Liberar',
    waitingSinceTime: 'Esperando desde',

    // Upgrade
    upgradeToPro: '⭐ Actualizar a Pro',
    unlockPower: 'Desbloquea todo el poder de SafeRoster',
    currentPlan: 'Plan Actual',
    freePlan: (name) => `Plan Gratuito — ${name}`,
    proPlan: 'Plan Pro',
    everythingYouNeed: 'Todo lo que necesitas para operar con seguridad',
    perMonth: 'por mes',
    securePayment: 'Pago seguro mediante Stripe. Cancela en cualquier momento.',
    upgradeButton: 'Actualizar a Pro — $29/mes →',
    redirecting: 'Redirigiendo al pago...',
    freeIncludes: 'El Plan Gratuito incluye:',
    freeFeatures: '15 registros diarios, registro con código QR, recogida con PIN, panel de personal',

    // ForgotPassword
    forgotPasswordTitle: 'Contraseña Olvidada',
    forgotPasswordSub: 'Ingresa tu correo y te enviaremos un enlace para restablecer',
    sendResetLink: 'Enviar Enlace de Restablecimiento',
    sending: 'Enviando...',
    backToLogin: '← Volver al Inicio de Sesión',
  },
};

export default translations;
